import { useEffect, useMemo, useState } from 'react';

export const useForm = ( initialForm = {}) => {
    const [ formState, setFormState ] = useState( initialForm );
    const [elementResetFlag, setElementResetFlag] = useState(false); //para select-lists mediante su `key`


    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const onInputNumberChange = ({ target }) => {
        const { name, value } = target;

        if (value < 0) return;
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const onSelectSearchChange = (event) => {
        const { name, value } = event.target
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const onDropZoneAcceptedFilesChange = (arrayAccepted) => {
        setFormState({
            ...formState,
            acceptedFiles: arrayAccepted
        });
    }

    const onDropZoneRejectionsFilesChange = (arrayRejections) => {
        setFormState({
            ...formState,
            fileRejections: arrayRejections
        });
    }

    const onResetForm = () => {
        setFormState( initialForm );
        setElementResetFlag(prevFlag => !prevFlag); //para select-lists mediante su `key
    }

    return {
        ...formState,
        formState,
        elementResetFlag,
        setFormState,
        onInputChange,
        onInputNumberChange,
        onSelectSearchChange,
        onResetForm,
        onDropZoneAcceptedFilesChange,
        onDropZoneRejectionsFilesChange
    }

}